import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { OkResponse } from "@typings/api";
import type { CreateVisitAttachmentsDTO } from "./type";

export async function createAttachmentsVisit(
  attachments: CreateVisitAttachmentsDTO,
): Promise<OkResponse> {
  const formData = new FormData();

  attachments.files.forEach((file) => formData.append("media", file));
  formData.append("fileType", attachments.fileType);

  const response = await apiClient.post<OkResponse>(
    apiPaths.visits.createAttachments(attachments.id),
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );

  return response.data;
}
